module.exports = __webpack_public_path__ + "static/media/AB_K18_12.b21551ea.jpg";